import { NavLink } from "react-router-dom";
import styles from "./Main.module.scss";
import picture from "./img/Main.jpg";
import pictureTwo from "./img/Main_2.jpg";
import pictureThree from "./img/Main_3.jpg";
import pictureFour from "./img/Main_4.jpg";
import pictureFive from "./img/Main_5.jpg";
import pictureSix from "./img/Main_6.jpg";

import logo from "./img/Logo.png";

function Main() {
  return (
    <div className={styles.container}>
      <div>
        <img className={styles.logo} src={logo} alt="logo" />
      </div>
      <div className={styles.trips}>
        <div className={styles.tripLinks}>
          <h1 className={styles.title}>Learn more about your trip</h1>
          <div className={styles.tripsGrid}>
            {/* change back to display grid when more trips are added */}
            <div>
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Scotland/May_20-29">
                  Scotland, May 20 - 29, 2026
                </NavLink>
              </div>
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="England/June_1-11-26">
                  England, June 1 - 11, 2026
                </NavLink>
              </div>
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Poland/August-26">
                  Poland, August 17 - 27, 2026
                </NavLink>
              </div>
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Ireland/September-26">
                  Ireland, September 14 - 23, 2026
                </NavLink>
              </div>
              {/* <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Italy-April-2024">
                  Italy, April 2 - 11, 2024
                </NavLink>
              </div>
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Greece-24" onClick={aprilTrip}

                >
                  Greece, April 22 - May 3, 2024
                </NavLink>
              </div>
              
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Poland-May-2024">
                  Poland, May 6-17, 2024
                </NavLink>
              </div> */}
              {/* <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="England/Spring-2026">
                  England, May 25 - June 3, 2026
                </NavLink>
              </div> */}
            </div>
            <div>
              {/* <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Greece-april-2025">
                  Greece, April 1 - 12, 2025
                </NavLink>
              </div>
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Germany-Spring-2025">
                  Germany, May 26 - June 6, 2025
                </NavLink>
              </div>
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Switzerland/June-2025">
                  Switzerland, June 9 - 20, 2025
                </NavLink>
              </div>

              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Switzerland/August_2-13-2025">
                  Switzerland, August 2 - 13, 2025
                </NavLink>
              </div>
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Switzerland/August_16-27-2025">
                  Switzerland, August 16 - 27, 2025
                </NavLink>
              </div> */}
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Israel/September-2026">
                  Israel & Petra, September 29 - October 10, 2026
                </NavLink>
              </div>
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Israel/October-2026">
                  Israel, October 20 - 30, 2026
                </NavLink>
              </div>
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Israel/November-2026">
                  Israel & Petra, November 2 - 13, 2026
                </NavLink>
              </div>
            </div>

            {/* <div>
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Patmos-september-2025">
                  Patmos, Athens & Corinth, September 24 - October 5, 2025
                </NavLink>
              </div>
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Israel-October-2025">
                  Israel and Petra Tour, October 15 - 29, 2025
                </NavLink>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className={styles.pictures}>
        <div className={styles.pictureBox}>
          <img src={picture} alt="Jerusalem" />
        </div>
        <div className={styles.pictureBox}>
          <img src={pictureTwo} alt="Jazreel valley" />
        </div>
        <div className={styles.pictureBox}>
          <img src={pictureFour} alt="Coliseum in Caesarea" />
        </div>
        <div className={styles.extraPicture}>
          <img src={pictureThree} alt="The Sea of Galilee" />
        </div>
      </div>
      <div className={styles.otherTrips}>
        <h2 className={styles.possibleTripsTitle}>Possible trips</h2>
        <div className={styles.possibleTrips}>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Switzerland/trip">Switzerland</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Israel/trip">Israel</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Poland/trip">Poland</NavLink>
          </div>{" "}
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Greece/trip">Greece</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Germany/trip">Germany</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Italy/trip">Italy</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Patmos/trip">Patmos</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Turkey/trip">Turkey</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="England/trip">England</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Scotland/trip">Scotland</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Ireland/trip">Ireland</NavLink>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
